// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-common-Button-module__root--2XYqz"};